module.exports = __webpack_public_path__ + "static/media/Income.06bd54ba.svg";